import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class MarkAsShippedBulkForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'fulfillmentOrders',
				'fulfillmentOrders[].fulfillmentOrderId',
				'fulfillmentOrders[].orderNumber',
				'fulfillmentOrders[].externalShipment',
				'fulfillmentOrders[].trackingNumber',
				'fulfillmentOrders[].shippingCost',
				'fulfillmentOrders[].shippingCostSurcharge',
				'fulfillmentOrders[].warehouseId',
				'fulfillmentOrders[].carrierServiceId',
				'fulfillmentOrders[].id',
			],
			labels: {
				'fulfillmentOrders[].fulfillmentOrderId': 'MARKASSHIPPEDBULKFORM.FO',
				'fulfillmentOrders[].orderNumber': 'MARKASSHIPPEDBULKFORM.MPO',
				'fulfillmentOrders[].trackingNumber': 'MARKASSHIPPEDBULKFORM.TRACKINGNUMBER',
				'fulfillmentOrders[].shippingCost': 'MARKASSHIPPEDBULKFORM.SHIPPINGCOST',
				'fulfillmentOrders[].shippingCostSurcharge': 'MARKASSHIPPEDBULKFORM.SURPLUSCHARGE',
				'fulfillmentOrders[].warehouseId': 'MARKASSHIPPEDBULKFORM.WAREHOUSE',
				'fulfillmentOrders[].carrierServiceId': 'MARKASSHIPPEDBULKFORM.CARRIERSERVICE',
			},
			rules: {
				'fulfillmentOrders[].trackingNumber': 'required',
				'fulfillmentOrders[].shippingCost': 'required|numeric|decimalLength|numericMinValue',
				'fulfillmentOrders[].shippingCostSurcharge': 'numeric|decimalLength|numericMinValue',
				'fulfillmentOrders[].warehouseId': 'required',
				'fulfillmentOrders[].carrierServiceId': 'required',
			},
			types: {
				'fulfillmentOrders[].externalShipment': 'checkbox',
			},
			values: {
				'fulfillmentOrders[].externalShipment': false,
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/MarkAsShippedBulkForm.js